<div class="landing-page-main change-history-page">
  <div class="landing-page-blocking" [hidden]="!blocked">
    <span>Loading...</span>
  </div>
  <div class="lading-page-content">
    <div class="landing-page-actions">
      <div class="action-group-left mobile-view-hide">
        <a class="back-button" (click)="moveBack()">
          <span> <i class="pi pi-angle-left"></i> </span>Back</a>
      </div>
      <div class="landing-page-legend">
        <div class="left-element page-title mobile-view-hide">
          <span>{{ title }}</span>
        </div>
        <div class="top-menu">
          <div class="ec-number">
            <span class="label">EC-1 # </span><span class="text">&nbsp;&nbsp;{{ selectedAuthority?.ec1Number }}</span>
          </div>
          <div class="horizontal-menu">
            <div class="inline-row"
              *ngIf="selectedAuthority && selectedAuthority.status === Status.ACTIVE.toString() && [eicStatus.RELEASED,eicStatus.REJECTED,eicStatus.CANCELLED].indexOf(newAuthority.loggedInEICDetail?.status) < 0; then thenBlock; else elseBlock">
            </div>
            <ng-template #thenBlock>
              <span class="text check-icon">
                <i class="csx-common_check check-aligment"></i>
              </span>
              <span class="check-margin">Active</span>
            </ng-template>
            <ng-template #elseBlock>
              <i class="csx-arrows_deallocate"></i>
              <span class="check-margin ">Released</span>
            </ng-template>
            <div class="inline-row">
              <span class="label">Changed</span>
              <span class="text">: {{ changeCount }} {{ changeCount > 1 ? 'times' : 'time' }}</span>
            </div>
            <div class="inline-row">
              <span class="label">Sharing </span>
              <span class="text">:&nbsp;{{ sharedCount }} People</span>
            </div>
          </div>
        </div>

        <div class="landing-page-table auth-history-center-align change-history">
          <create-table-header [columnNames]="columnNames"></create-table-header>
          <div class="heading-authoritiy-current">
            CURRENT AUTHORITY
          </div>

          <div class="current-authority-table">
            <authority-row [authority]="selectedAuthority" [isAuthorityHistory]="isAuthorityHistory"></authority-row>
          </div>
          <div *ngIf="authorityHistoryCount > 0">
            <div class="expand-collapse-history">
              <p (click)="showHistory = !showHistory">
                <span *ngIf="!showHistory">+&nbsp;Show all changes</span>
                <span *ngIf="showHistory">-&nbsp;Hide changes</span>&nbsp;<span>({{ authorityHistoryCount }})</span>
              </p>
            </div>
            <div class="heading-authoritiy-previous">PREVIOUS CHANGES</div>

            <div [hidden]="!showHistory">
              <div *ngFor="let authorityHistory of authorityHistories | slice: 0:authorityHistories?.length - 1"
                class="history-row">
                <authority-modification [authorityHistoryChanges]="authorityHistory.authorityHistoryChange"
                  [authorityHistoryCommonChange]="authorityHistory.authorityHistoryCommonChange"></authority-modification>
                <div class="history-table">
                  <authority-row [authority]="authorityHistory.authoritySnapshot"
                    [isAuthorityHistory]="isAuthorityHistory"></authority-row>
                </div>
              </div>
            </div>

            <div class="display-history-mobile">
              <div *ngFor="let authorityHistory of authorityHistories | slice: 0:authorityHistories?.length - 1"
                class="history-row">
                <p-accordion [multiple]="true" styleClass="history-accordian">
                  <p-accordionTab>
                    <p-header>
                      <authority-modification [isInitialAuthority]="false"
                        [authorityHistoryChanges]="authorityHistory.authorityHistoryChange"
                        [authorityHistoryCommonChange]="authorityHistory.authorityHistoryCommonChange"></authority-modification>
                    </p-header>
                    <div class="history-table">
                      <authority-row [authority]="authorityHistory.authoritySnapshot"
                        [isAuthorityHistory]="isAuthorityHistory"></authority-row>
                    </div>
                  </p-accordionTab>
                </p-accordion>
              </div>
            </div>
          </div>

          <div class="history-row" *ngIf="initialAuthority">
            <div class="display-history-web">
              <authority-modification [isInitialAuthority]="isAuthorityHistory"
                [authorityHistoryChanges]="initialAuthority.authorityHistoryChange"
                [authorityHistoryCommonChange]="initialAuthority.authorityHistoryCommonChange"></authority-modification>
              <div class="atm-table-table initial-row">
                <authority-row [authority]="initialAuthority.authoritySnapshot"
                  [isAuthorityHistory]="isAuthorityHistory"></authority-row>
              </div>
            </div>
            <div class="display-history-mobile">
              <p-accordion [multiple]="true" styleClass="history-accordian">
                <p-accordionTab>
                  <p-header>
                    <authority-modification [isInitialAuthority]="isAuthorityHistory"
                      [authorityHistoryChanges]="initialAuthority.authorityHistoryChange"
                      [authorityHistoryCommonChange]="initialAuthority.authorityHistoryCommonChange"></authority-modification>
                  </p-header>
                  <div class="history-table">
                    <authority-row [authority]="initialAuthority.authoritySnapshot"
                      [isAuthorityHistory]="isAuthorityHistory"></authority-row>
                  </div>
                </p-accordionTab>
              </p-accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>